module.exports = function() {
	return new Worker(__webpack_public_path__ + "24d8488feb58e537db84.orders.wrkr.js");
};